import { truncate } from "lodash";
import React from "react";
import { IMaskInput } from "react-imask";

type PhoneMaskedInputProps = {
  onChange: (event: { target: { name: string; value: string } }) => void;
  name: string;
};

const PhoneMaskedInput = React.forwardRef<
  HTMLInputElement,
  PhoneMaskedInputProps
>(function TextMaskCustom(props, ref) {
  const { onChange, ...other } = props;
  return (
    <IMaskInput
      {...other}
      mask="(#00) 000-0000"
      definitions={{
        "#": /[1-9]/,
      }}
      maxLength={14}
      inputRef={ref}
      onAccept={(value: any) => {
        onChange({
          target: { name: props.name, value: truncate(value, { length: 14 }) },
        });
      }}
      overwrite
    />
  );
});

export default PhoneMaskedInput;
